import { useContext } from 'react';
import LanguageContext from '../context/language.context';
import skills from '../translations/skills';
import styles from '../style/skills.module.css';
import { publicAsset } from '../utils/publicAsset';

export function Skills() {
  const { language } = useContext(LanguageContext);
  return (
    <section id="skills" className={ styles.container } aria-labelledby="skills-heading">
      <div className={ styles.subcontainer }>
        <div className={ styles.containerTitle }>
          <h1 id="skills-heading" className={ styles.title }>{skills[language].title}</h1>
          <p className={ styles.subtitle }>{skills[language].subTitle}</p>
        </div>
        <div className={ styles.main }>
          {skills.screenSkills.map((skill) => (
            <div key={ skill.titleEN } className={ styles.skill }>
              <img src={ publicAsset(skill.image) } alt={ skill[`title${language.toUpperCase()}`] } />
              <div className={ styles.textContainer }>
                <h3 className={ styles.skillTitle }>{skill[`title${language.toUpperCase()}`]}</h3>
                <p className={ styles.text }>
                  {skill[`description${language.toUpperCase()}`]}
                </p>
                <h4 className={ styles.languageTitle }>
                  {skill[`languagesTitle${language.toUpperCase()}`]}
                </h4>
                <ul className={ styles.languages }>
                  {skill.languages.map((lang) => (
                    <li key={ lang }>{lang}</li>
                  ))}
                </ul>
                <h4 className={ styles.toolsTitle }>
                  {skill[`toolsTitle${language.toUpperCase()}`]}
                </h4>
                <ul className={ styles.tools }>
                  {skill.tools.map((tool) => (
                    <li key={ tool.en }>{tool[language]}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
